import { VIDEOSTATUS, EVENTTYPES, SUB_MSGTYPE, SUB_CMD } from '../constants';
import { stateTimer } from '../utils';
import logReport from '../monitor/qdMonitor';
import videoRing from '../videoRing';
import {
  POST_VIDEO_CANCEL_REPORT,
} from '@/utils/api';
import DOMAIN from '@/imsdk/domain';
const domain = DOMAIN.getSDKDomain();
const noToastEvent = [
  EVENTTYPES.iniCancel,
  EVENTTYPES.errorTRTC,
  EVENTTYPES.unKnow,
];
export default {
  data() {
    return {
      roomid: '',
    };
  },
  computed: {
    ispc() {
      return this.$platform.pc;
    },
  },
  methods: {
    // 接收，音视频事件推送
    // @param {uint32_call_type: 1视频 2音频}
    handleNotifyRtc(data) {
      const oldActionTime = parseInt(localStorage.getItem('videoActionTime'));
      const newActionTime = data.msg_rtc_action_info.uint64_action_time;
      // 推送去重
      if (oldActionTime && oldActionTime >= newActionTime) {
        return;
      }
      localStorage.setItem('videoActionTime', newActionTime);
      logReport({ message: `音视频:收到sc消息,${JSON.stringify(data)}` });
      // 如果是被叫开启，那么就在此处纪录一下信息
      if (
        data.msg_rtc_action_info
            && data.uint32_roomid
            && data.msg_rtc_action_info.uint32_action_event === EVENTTYPES.iniCall
      ) {
        logReport({ message: `音视频:收到邀请,${data.uint32_roomid}` });
      }
      const act = data.msg_rtc_action_info.uint32_action_event;
      console.log(`eventType=====${act}`);
      if (act !== EVENTTYPES.iniCall && data.uint32_roomid !== this.roomid) {
        logReport(
          {
            message: `音视频:上次房间消息:${JSON.stringify(data)}`,
          },
          false,
        );
        return;
      }
      this.mediaType = data.uint32_call_type;
      this.roomid = data.uint32_roomid;
      switch (act) {
        case EVENTTYPES.iniCall:
          this.iniCallAction(data);
          break;
          // 发起方拨打时取消
        case EVENTTYPES.iniCancel:
          logReport({ message: '音视频:ring->idle:peerHangup' }, false);
          // 发起方接通后主动挂断
        case EVENTTYPES.iniHangup:
        case EVENTTYPES.recRefuse:
        case EVENTTYPES.recAcceptFail:
        case EVENTTYPES.recHangup:
        case EVENTTYPES.thirdHangup:
        case EVENTTYPES.notSurport:
        case EVENTTYPES.errorTRTC:
        case EVENTTYPES.die:
          this.exitSdk({ event: 'peerHangup' });
          this.statusReport(VIDEOSTATUS.idle);
          logReport({
            message: `音视频:对方${act},导致挂断`,
          });
          break;
      }
    },
    // 初始化收到对方101呼叫行为
    iniCallAction(data) {
      const self = this;
      if (data.uint32_roomid) {
        logReport({ message: '音视频:被叫' });
        // pc如果trtc不支持不能发起音视频通话
        if (this.ispc && !this.surportTRTC) {
          this.videoAct(EVENTTYPES.notSurport);
          return;
        }
        /* 被叫 */
        this.$refs.videoRing?.showDialling(data);
        stateTimer.make(
          () => {
            logReport({ message: '音视频:ring->idle:timeout' }, false);
            // 取消
            self.videoAct(EVENTTYPES.recAcceptFail);
            self.exitSdk({ event: 'timeOuterror' });
          },
          {
            id: 'dialling_timeout_timer',
            delay: 70 * 1000,
          },
        );
      } else {
        logReport({ message: '被呼叫参数错误' }, false);
      }
    },
    // 新版本webim音视频行为http接口上报 201，203，205，206
    videoAct(act) {
      const { kfuin, visitorid } = this.wpaDetail;
      const params = {
        rtc_part_action_report_req: {
          uint64_kfuin: kfuin,
          uint32_roomid: this.roomid,
          uint32_action_event: act,
          user_info: {
            user_account_info: {
              uint32_account_type: 4,
              str_account_id: visitorid,
              // "int64_fakeuin": 1496000000
            },
          },
        },
      };
      logReport({ message: `音视频:事件上报,${JSON.stringify(params)}` });
      this.$ajax.post(domain.api + POST_VIDEO_CANCEL_REPORT, params)
        .then((res) => {
          if (res.data.code === 0) {
          } else {
            logReport({
              message: `音视频:新版本挂断报错，${res.data}`,
            });
          }
        });
    },
    TrtcErrorReport(reason) {
      logReport({
        message: `音视频:trtcerror, ${JSON.stringify({ code: 1, reason })}`,
      });
      this.eventReport({
        eventType: EVENTTYPES.errorTRTC,
        bytes_extend_info: JSON.stringify({
          code: 1,
          reason,
        }),
      });
    },
    // 状态上报
    statusReport(status) {
      const { kfuin, visitorid } = this.wpaDetail;
      const param = {
        rtc_status_report_req: {
          uint64_kfuin: parseInt(kfuin),
          account_info: {
            uint32_account_type: 4,
            str_account_id: visitorid,
            int64_fakeuin: 0,
          },
          uint32_clienttype: 5,
          uint32_status: status,
          uint64_action_time: Math.floor(new Date()),
          uint32_roomid: this.roomid,
        },
      };
      logReport({
        message: `音视频:状态上报,${JSON.stringify(param)}`,
      });
      const rs = this.$refs.aio?.sendCmdMessage(SUB_CMD.CMD_INNER_RTC_STATUS_REPORT_REQ, param, SUB_MSGTYPE);
      rs.then((res) => {
        logReport({
          message: `音视频:状态上报返回,${JSON.stringify(res)}`,
        });
        if (res && res.msg_ret_info.uint32_ret_code) {
          logReport({
            message: `音视频:状态上报失败,${JSON.stringify(res)}`,
          });
        }
      });
    },
    // 事件/动作上报
    eventReport(data) {
      const action = data.eventType;
      const { roomid } = this;
      const { kfuin, visitorid } = this.wpaDetail;
      let hangupProcess = false;
      const param = {
        rtc_action_report_req: {
          uint64_kfuin: kfuin,
          uint32_roomid: roomid,
          msg_rtc_action_info: {
            uint32_action_event: action,
            bytes_extend_info: data.bytes_extend_info,
            uint32_clienttype: 5,
            uint64_action_time: Math.floor(new Date() / 1000),
            action_user_info: {
              // B侧固定1。 1:工号 3:微信公众号 4:webim 7:微信小程序 50:imsdk
              uint32_account_type: 4,
              str_account_id: visitorid,
              int64_fakeuin: 0,
            },
          },
        },
      };
      if ([EVENTTYPES.iniCancel, EVENTTYPES.recRefuse, EVENTTYPES.recHangup].indexOf(action)) {
        hangupProcess = true;
        logReport({
          message: '音视频:挂断',
        });
      }
      logReport({ message: `音视频:事件上报,${JSON.stringify(param)}` });
      const rs = this.$refs.aio?.sendCmdMessage(SUB_CMD.CMD_INNER_RTC_ACTION_REPORT_REQ, param, SUB_MSGTYPE);
      rs.then((res) => {
        logReport({ message: `音视频:事件上报返回,${JSON.stringify(res)}` });

        if (res && res.msg_ret_info.uint32_ret_code) {
          const errcode = res.msg_ret_info.uint32_ret_code;
          if (errcode === 10003) {
            this.eventAckHandler(errcode);
          }
          if (noToastEvent.indexOf(data.eventType) === -1) {
            this.$message.error(res.msg_ret_info.str_error_msg);
          }
          logReport({ message: `音视频:事件上报失败,${JSON.stringify(res)}` });
        } else {
          if (hangupProcess) {
            logReport({ message: '音视频:挂断成功' });
          }
        }
      });
    },
    // socket事件ack处理
    eventAckHandler(errcode) {
      switch (errcode) {
        case 10004:
          logReport({ message: '10004:对方忙' }, false);
          break;
        case 10029:
          logReport({ message: '10029:未知错误' }, false);
          break;
        case 10003:
          logReport({ message: '10003:自己忙(上次异常退出)，上报idle后重试' });
          // 自己忙(上次异常退出)，上报idle后重试
          this.statusReport(VIDEOSTATUS.idle);
          break;
        default:
          logReport({ message: `unknow error code: ${errcode}` }, false);
      }
    },
    // 通话结束或其他情况
    exitSdk({ event = 'unknown' } = {}) {
      let msg = '';
      switch (event) {
        case 'hangup':
          msg = '已拒绝';
          break;
        case 'recAcceptFail': // 对方不接挂断
          msg = `${this.dir === 'c2b' ? '对方' : ''}未接听`;
          break;
        case 'peerHangup':  // 通话中对方挂断
          msg = '对方已取消';
          break;
        case 'TRTCError':
          msg = '设备不支持';
          break;
        default:
          msg = '';
      }
      if (msg) {
        logReport({ message: `音视频:结束,原因${event}` });
        // this.renderVideoMsg(msg);
      } else {
        logReport({ message: `音视频:结束失败,原因${event}` });
      }
      // 关闭视讯窗口
      if (this.otherWindow) {
        this.otherWindow.close();
        this.otherWindow = null;
      }
      this.$refs.videoRing?.stopRing();
      videoRing.stop();
    },
  },
};
